import React from 'react';

const BadgeTrack = ({ children }) => {
    return(
        <span className={`badgeTrack`}>{children}</span>
    )
}

export default BadgeTrack;